import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from '../components/Toast';
import { api } from '../lib/api';

export default function ResetPassword() {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const t = p.get('token');
    if (t) setToken(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setDone(true);
      toast.success('Password reset successfully!');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Link to="/"><span style={{fontSize:32}}>🍽️</span> <span className="serif" style={{fontSize:22,fontWeight:700}}>QR Menu</span></Link>
        </div>
        {!done ? (
          <>
            <h1 className="auth-title">Reset Password</h1>
            <p className="auth-subtitle">Enter your new password below</p>
            {!token && <div style={{background:'#fef9c3',border:'1px solid #fde047',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:16,color:'#854d0e'}}>⚠️ No reset token found. Please use the link from the forgot password page.</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="form-group">
                <label className="form-label">New Password</label>
                <div className="form-input-icon">
                  <input type={showPw ? 'text' : 'password'} className="form-input input-pr" placeholder="Min. 6 characters" value={password} onChange={e => setPassword(e.target.value)} required />
                  <button type="button" className="input-icon-right" onClick={() => setShowPw(!showPw)}>{showPw ? '🙈' : '👁️'}</button>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input type="password" className="form-input" placeholder="Re-enter password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
                {confirm && password !== confirm && <p className="text-red text-xs mt-1">Passwords do not match</p>}
              </div>
              <button type="submit" className="btn btn-primary w-full btn-lg" disabled={loading || !token}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <div style={{fontSize:48,marginBottom:16}}>🎉</div>
            <h1 className="auth-title">Password Reset!</h1>
            <p className="auth-subtitle">Redirecting to login page...</p>
            <Link to="/login" className="btn btn-primary w-full btn-lg mt-4">Go to Login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
